export default "__VITE_ASSET__BxiuQ1tH__"